import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';

class Tooltip extends React.Component {
    render() {
        const { props } = this;
        return (
            <AntdTooltip mouseEnterDelay={0.5} {...props}>
                {props.children}
            </AntdTooltip>
        );
    }
}

export default Tooltip;
